import React, { useMemo } from 'react';
import { Field, useForm, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import WithLabel, { LABEL_STYLES } from '../../../../../components/with-label/WithLabel';
import WithError from '../../../../../components/with-error/WithError';
import CommonDropdown from '../../../../../components/common-dropdown/CommonDropdown';
import useMonthsOptions from '../../../../../hooks/useMonthsOptions';
import useYearsOptions from '../../../../../hooks/useYearsOptions';
import getMaxSonarDate from '../../../../../utils/getMaxSonarDate';
import getPossibleMonths from '../../../../../utils/getPossibleMonths';

import scss from '../SonarCreationForm.module.scss';

const StartFromField = ({ isLoading, onBlur }) => {
  const { t } = useTranslation('projects');

  const { change } = useForm();
  const { values } = useFormState();

  const maxDate = getMaxSonarDate();

  const monthsOptions = useMonthsOptions();
  const yearOptions = useYearsOptions({ endYearProps: +maxDate.year });

  const possibleMonths = useMemo(
    () => getPossibleMonths(+values.startingFromYear, monthsOptions, maxDate),
    [values.startingFromYear, monthsOptions, maxDate],
  );

  const handleChangeStartMonth = (value) => {
    change('startingFromMonth', value);
    onBlur('startingFromMonth', value);
  };

  const handleChangeStartYear = (value) => {
    change('startingFromYear', value);

    const newPossibleMonth = getPossibleMonths(+value, monthsOptions, maxDate);

    if (!newPossibleMonth.map(({ value }) => +value).includes(+values.startingFromMonth)) {
      change('startingFromMonth', '');
    } else {
      onBlur('startingFromYear', value);
    }
  };

  return (
    <WithLabel variant={LABEL_STYLES.ALIGNED} label={`${t('startingFrom')}:`} isBold extraClassName={scss.inputRow}>
      <div className={scss.startingFromDropdowns}>
        <Field name='startingFromMonth' autoComplete='starting-from-month'>
          {({ meta, input }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonDropdown
                value={input.value}
                options={possibleMonths}
                onSelect={handleChangeStartMonth}
                name={input.name}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                disabled={isLoading}
                onBlur={input.onBlur}
              />
            </WithError>
          )}
        </Field>

        <Field name='startingFromYear' autoComplete='starting-from-year'>
          {({ meta, input }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)} isAbsolute>
              <CommonDropdown
                value={input.value}
                options={yearOptions}
                onSelect={handleChangeStartYear}
                name={input.name}
                onFocus={input.onFocus}
                isError={meta.touched && meta.error}
                disabled={isLoading}
                onBlur={input.onBlur}
              />
            </WithError>
          )}
        </Field>
      </div>
    </WithLabel>
  );
};

export default StartFromField;
